module.exports = __webpack_public_path__ + "static/media/suplimentary_form.73cd518f.png";